/*
 * @Author: caiqin.xie
 * @since: 2023-07-20 09:53:13
 * @lastTime: 2023-11-10 17:01:24
 * @LastEditors: caiqin.xie
 * @message: 新闻组件
 */
import React from 'react'
import styles from './index.module.scss'
import LazyMedia from '@/components/LazyMedia'
import { INews } from '@/common/types'

interface IProps {
  ctry: string;
  newsData: INews; // 新闻数据
  className?: string;
  imgClassName?: string; // 图片容器样式
  contentClassName?: string; // 内容容器样式
}

const NewsItem = (props: IProps) => {
  const { ctry, newsData, className, imgClassName, contentClassName } = props
  return (
    <a href={`/${ctry}/newsroom/${newsData.seoUrl}`} target="_blank" className={`${styles['news-item']} ${className}`}>
      <div className={`${styles['news-pic']} ${imgClassName}`}>
        <LazyMedia type="image" LazyClassName="full-wh" src={newsData?.cover} alt={newsData?.coverAlt} />
      </div>
      <div className={`${styles['news-content']} ${contentClassName}`}>
        <h3 className={styles['news-title']}>{newsData?.title}</h3>
        <p className={styles['news-date']}>{newsData?.publishDate}</p>
      </div>
    </a>
  )
}
export default NewsItem
